"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components2 = require("@/components");
var _vuex = require("vuex");
var _validators = require("vuelidate/lib/validators");
var _auth2 = require("@/utils/auth");
var _authGuard = require("@/auth/authGuard");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'LoginPage',
  bodyClass: 'login-page',
  components: _defineProperty(_defineProperty(_defineProperty({}, _components2.Button.name, _components2.Button), _components2.FormGroupInput.name, _components2.FormGroupInput), "AppInput", _components2.AppInput),
  data: function data() {
    return {
      form: {
        Document: '',
        UserPassword: ''
      },
      errors: [],
      loadingComponent: null
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['device', 'getMenuListAccess'])), {}, {
    isMobile: function isMobile() {
      return this.device === 'mobile';
    }
  }),
  created: function created() {
    var cookieConsent = this.checkCookieConsent('cookieConsent');
    if (!cookieConsent) {
      this.acceptCookie();
    }
  },
  validations: {
    form: {
      Document: {
        required: _validators.required
      },
      UserPassword: {
        required: _validators.required
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['login', 'fetchAndSetMenuAccess'])), {}, {
    loading: function loading(status) {
      if (!status) {
        return this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open({
        container: null
      });
    },
    checkForm: function checkForm(e) {
      e.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.errors.push("Por favor, verifique os campos obrigat\xF3rios!");
        return this.$buefy.toast.open({
          duration: 5000,
          message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
          position: 'is-top',
          type: 'is-danger'
        });
      }
      this.auth();
    },
    auth: function () {
      var _auth = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _dataUser$user, _dataUser$user2, dataUser, menu, _dataUser;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading(true);
              _context.n = 1;
              return this.login({
                Document: this.form.Document,
                UserPassword: this.form.UserPassword
              });
            case 1:
              data = _context.v;
              this.loading(false);
              if (!data) {
                _context.n = 5;
                break;
              }
              dataUser = data.data; // set config GA
              this.$gtag.config({
                'client_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user = dataUser.user) === null || _dataUser$user === void 0 ? void 0 : _dataUser$user._id
              });

              // set event user
              this.$gtag.event('login_platform', {
                'event_category': 'access',
                'event_label': 'login',
                'value': {
                  'client_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user2 = dataUser.user) === null || _dataUser$user2 === void 0 ? void 0 : _dataUser$user2._id
                }
              });

              // get menu
              _context.n = 2;
              return this.fetchAndSetMenuAccess(dataUser.user.roleId);
            case 2:
              menu = _context.v;
              if (!menu) {
                _context.n = 5;
                break;
              }
              if (!((0, _auth2.getAccessData)().activeBusinessUnit || (0, _authGuard.isUserAdmin)())) {
                _context.n = 3;
                break;
              }
              this.redirect();
              _context.n = 5;
              break;
            case 3:
              _dataUser = data.data;
              if (_dataUser.businessUnits.length) {
                _context.n = 4;
                break;
              }
              return _context.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "Voc\xEA n\xE3o est\xE1 vinculado a uma Unidade de Neg\xF3cio.",
                position: 'is-top',
                type: 'is-danger'
              }));
            case 4:
              this.openModal();
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function auth() {
        return _auth.apply(this, arguments);
      }
      return auth;
    }(),
    redirect: function () {
      var _redirect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.getMenuListAccess.length) {
                this.$router.push({
                  path: this.getMenuListAccess[0].path
                });
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function redirect() {
        return _redirect.apply(this, arguments);
      }
      return redirect;
    }(),
    checkCookieConsent: function checkCookieConsent() {
      var cookies = document.cookie.split('; ');
      var checkCookie = cookies.some(function (cookie) {
        return cookie === 'analytics=true';
      });
      return checkCookie;
    },
    openModal: function openModal() {
      this.$buefy.modal.open({
        parent: this,
        component: _components2.ModalBusinessUnit,
        hasModalCard: true,
        trapFocus: true,
        canCancel: [],
        customClass: 'modal-select-business-unit-component',
        props: {
          action: this.redirect
        }
      });
    },
    acceptCookie: function acceptCookie() {
      this.$buefy.modal.open({
        parent: this,
        component: _components2.ModalAcceptCookies,
        hasModalCard: true,
        customClass: 'modal-confirm-reject-component',
        trapFocus: true,
        canCancel: []
      });
    }
  })
};